<iframe class="cover-page" [src]="iframeUrl" title="Document Preview" frameborder="0"></iframe>
